import {
  AfterViewInit,
  Component,
  OnInit,
  ViewChild,
  HostListener,
} from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SwUpdate } from "@angular/service-worker";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";
import { JwtAuthorizationComponent } from "./shared/common-components/jwt-authorization/pages/jwt-authorization/jwt-authorization.component";
import { LoadingSpinnerService } from "./shared/services/loading-spinner.service";
import { VersionManagementService } from "./shared/services/version-management.service";
import { CrewbidHelper } from "./shared/utility/helper";
declare let $;

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.css"],
    standalone: false
})
export class AppComponent implements AfterViewInit, OnInit {
  title = "Crewbid-WebApp";
  @ViewChild("authentication")
  public auth: JwtAuthorizationComponent;
  public version = "2.0";
  public localVersion: string;
  private _updateLaterFlag = false;
  loading: boolean;
  loaderText: any;
  isPortrait: boolean;

  @HostListener("window:orientationchange", ["$event"])
  onOrientationChange(event) {
    setTimeout(() => {      
      this.isPortrait = window.matchMedia("(orientation: portrait)").matches;
    }, 50);
  }
  ngAfterViewInit(): void {
    if (this.swUpdate.isEnabled) {
      setTimeout(() => {
        this.checkAndSyncVersion();
      }, 5000);
    }
  }
  constructor(
    private swUpdate: SwUpdate,
    private helper: CrewbidHelper,
    private versionService: VersionManagementService,
    public snackBar: MatSnackBar,
    public loaderService: LoadingSpinnerService
  ) {
    this.localVersion = environment.version;
    document.addEventListener(
      "visibilitychange",
      () => {
        if (!this._updateLaterFlag)
          setTimeout(() => {
            this.checkAndSyncVersion();
          }, 5000);
      },
      false
    );
    this.loaderService.loading.subscribe((val) => {
      this.loaderText = val.text ? val.text : "";
      this.loading = val.isLoad ? val.isLoad : false;
    });
    this.prompInstall();
  }
  ngOnInit(): void {
    this.isPortrait = window.matchMedia("(orientation: portrait)").matches;    
  }
  /**
   * @method checkAndSyncVersion - Check and Sync Version of the Application
   */
  checkAndSyncVersion(): void {
    try {
      let ver = environment.version;
      this.versionService.GetAppVersion(ver).subscribe(
        (res) => {
          if (res) {
            this.version = res.VersionNumber;
            ver = localStorage.getItem("appVersion");
            if (!this.localVersion) {
              this.localVersion = "10.0.0.0";
            }
            const localVersionArr = this.localVersion.split(".");
            const incomingVersion = this.version.split(".");
            const result = this.helper.compareVersion(
              localVersionArr,
              incomingVersion
            );
            if (result === 1) {
              Swal.fire({
                title: "",
                text:
                  "You do not have the newest Version of Crewbid. You are using version " +
                  this.localVersion +
                  " and the newest version is " +
                  this.version,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Update Now",
                cancelButtonText: "Exit",
                allowOutsideClick: false,
              }).then((result) => {
                if (result.value) {
                  this.clearCache();
                } else this.updateModalExitBtnHandler();
              });
            }
          }
        },
        (error) => {
          if (error.status === 401) {
            this.auth.invoke();
          } else {
            console.log("http error" + JSON.stringify(error));
            //this.crashMail.sendCrashMail(`Function Name: checkAndSyncVersion  ${error.stack.toString()}`);
          }
        }
      );
    } catch (error) {
      //this.crashMail.sendCrashMail(`Function Name: checkAndSyncVersion  ${error.stack.toString()}`);
    }
  }
  /**
   * @method clearCache - Clear Cache memory
   */
  public clearCache(): void {
    try {
      this.loaderService.showSpinner(
        "Updating the app. which might took few seconds and couple of reloads. Please be patient"
      );

      this.forceSWupdate();
      setTimeout(() => {
        document.location.reload();
      });
    } catch (error) {
      //this.crashMail.sendCrashMail(`Function Name: clearCache  ${error.stack.toString()}`);
    }
  }
  /**
   * @method forceSWupdate - Force Update version
   */
  forceSWupdate() {
    this.updateModalExitBtnHandler();
    if (caches) {
      caches.keys().then((arr) => {
        arr.forEach((key) => {
          caches.delete(key);
        });
      });
    }
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (const registration of registrations) {
          registration.unregister();
        }
        setTimeout(() => {
          document.location.reload();
        }, 20000);
      });
    }
  }
  /**
   * @method updateModalExitBtnHandler - Update Modal Exit Button
   */
  public updateModalExitBtnHandler = (): void => {
    this._updateLaterFlag = true;
  };

  /**
   * @method prompInstall for pwa instalation
   */
  public prompInstall() {
    try {
      if ((navigator as any).standalone == undefined) {
        // It's not iOS
        if (window.matchMedia("(display-mode: browser").matches) {
          let durationForSnackBar = 500000;
          // We are in the browser
          window.addEventListener("beforeinstallprompt", (event) => {
            event.preventDefault();
            if (durationForSnackBar > 0) {
              const sb = this.snackBar.open(
                "Do you want to install this App?",
                "Install",
                { duration: durationForSnackBar }
              );

              sb.onAction().subscribe(() => {
                (event as any).prompt();
                (event as any).userChoice.then((result) => {
                  if (result.outcome == "dismissed") {
                    durationForSnackBar = 0;
                    //TODO: Track no installation
                  } else {
                    //TODO: It was installed
                  }
                });
              });
            }
            return false;
          });
        }
      }
    } catch (error) {
      // this.crashMail.sendCrashMail(`Function Name: prompInstall  ${error.stack.toString()}`);
    }
  }
}

